export const ANTISINGOV_MESSAGE_PORTAL_CODE = 'AntiSinGov.Message.Portal';
